import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var Svg18RemoveDark = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.colorV2.colorSet.grey400,
        fillOpacity: 0.5,
        d: "M9 1.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15m0 1a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13"
      }), /*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.colorV2.colorSet.grey300,
        d: "m6.713 6.017.07.058L9 8.293l2.218-2.218a.5.5 0 0 1 .765.638l-.058.07L9.707 9l2.218 2.218a.5.5 0 0 1-.638.765l-.07-.058L9 9.707l-2.218 2.218a.5.5 0 0 1-.765-.638l.058-.07L8.293 9 6.075 6.782a.5.5 0 0 1 .562-.808z"
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18RemoveDark$1 = Svg18RemoveDark;

export { Svg18RemoveDark$1 as default };
